import React, { useState } from 'react'
// MUI Imports
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import EmailIcon from '@mui/icons-material/Email'
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled'
import SystemSecurityUpdateWarningIcon from '@mui/icons-material/SystemSecurityUpdateWarning'
import { Divider, Stack } from '@mui/material'

const ContactLinks = ({ user }) => {
  const nok = user.employee.personnelInfo?.emergencyContact ?? {}
  const nok2 = user.employee.personnelInfo?.emergencyContact2 ?? {}
  const [openNOK, setOpenNOK] = useState(false)

  return (
    <Box gap={1} display="flex" flexDirection="column" marginTop={2}>
      {user.employee.personnelInfo.phoneNumber1 && (
        <a
          href={`tel:${user.employee.personnelInfo.phoneNumber1}`}
          style={{ textDecoration: 'none' }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <PhoneEnabledIcon fontSize="small" color="third" />
            <Typography fontSize={14} variant="title2">
              {user.employee.personnelInfo.phoneNumber1}
            </Typography>
          </Box>
        </a>
      )}
      {user.email && (
        <a
          href={`mailto:${user.email}`}
          style={{ textDecoration: 'none' }}
          target="_blank"
        >
          <Box display="flex" alignItems="center" gap={2}>
            <EmailIcon color="third" fontSize="small" />
            <Typography fontSize={14} variant="title2">
              {user.email}
            </Typography>
          </Box>
        </a>
      )}
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        sx={{ cursor: 'pointer' }}
        onClick={() => setOpenNOK(true)}
      >
        <SystemSecurityUpdateWarningIcon color="third" fontSize="small" />
        <Typography fontSize={14} variant="title2">
          Emergency Contact Details
        </Typography>
      </Box>
      <Modal open={openNOK} onClose={() => setOpenNOK(false)}>
        <Box sx={nokModalStyle} display="flex" flexDirection="column">
          <Stack gap={1} divider={<Divider />}>
            <Typography variant="title2" fontSize={16}>
              Emergency Contacts for {user.firstName ?? ''}
            </Typography>
            <Stack>
              <Typography>
                <b>Name: </b>
                {`${nok.firstName ?? ''} ${nok.lastName ?? ''}`}
              </Typography>
              <Typography>
                <b>Number: </b>
                {`${nok.phone1 ?? '-'} ${nok.phone2 ?? ''}`}
              </Typography>
              <Typography>
                <b>Relationship: </b>
                {nok.relationship ?? '-'}
              </Typography>
            </Stack>
            <Stack>
              <Typography>
                <b>Name: </b>
                {`${nok2.firstName ?? ''} ${nok2.lastName ?? ''}`}
              </Typography>
              <Typography>
                <b>Number: </b>
                {`${nok2.phone1 ?? '-'} ${nok2.phone2 ?? ''}`}
              </Typography>
              <Typography>
                <b>Relationship: </b>
                {nok2.relationship ?? '-'}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </Box>
  )
}

export default ContactLinks

const nokModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '20rem',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  borderColor: 'none',
  maxHeight: 500,
  overflow: 'auto',
  padding: 1,
  outline: 'none',
}
